import { useDispatch, useSelector } from "../../services/hooks";
import { useEffect } from "react";
import { getUser } from "../../services/login/actions";
import { Route, Routes } from "react-router-dom";
import styles from "./profile.module.css";
import { ProfileInfo } from "./profile-info";
import { ProfileStatistics } from "./profile-statistics";
import { ProfileMenuLayout } from "./profile-menu-layout";

export function Profile(): JSX.Element {
  const dispatch = useDispatch();
  const user = useSelector((store) => store.loginReducer.user);

  useEffect(() => {
    if (!user) {
      dispatch(getUser());
    }
  }, [dispatch, user]);

  return (
    <div className={styles.page}>
      <ProfileMenuLayout>
        <Routes>
          <Route index element={<ProfileInfo user={user} />} />
          <Route path="statistics" element={<ProfileStatistics />} />
        </Routes>
      </ProfileMenuLayout>
    </div>
  );
}
